import React from 'react'

import GlobalLayout, { GlobalLayoutProps } from 'global/components/lib/layout/Layout'

import AdminNavbar from 'admin/components/lib/layout/Navbar'

export default function Layout(props: GlobalLayoutProps): JSX.Element {
  return <GlobalLayout navbar={<AdminNavbar />} isLicenseBannerEnabled={false} {...props} />
}
